import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block bg-background-50 rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-1"
      data-product-shop="true"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={comic.cover}
          alt={comic.title}
          title={`${comic.title} - 韩漫网 在线漫画 韩国漫画`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2 flex flex-col gap-1">
          {comic.isHot && (
            <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
              热门
            </span>
          )}
          {comic.isNew && (
            <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
              新作
            </span>
          )}
        </div>
        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 bg-background-950/70 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
            {comic.rating}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <span className="text-background-50 text-xs whitespace-nowrap">{comic.status}</span>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1 whitespace-nowrap">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-600 mt-1 line-clamp-2">
          {comic.description}
        </p>
        <div className="flex items-center justify-between mt-3">
          <span className="text-xs text-foreground-500 whitespace-nowrap">{comic.author}</span>
          <span className="text-xs text-foreground-400 whitespace-nowrap">{comic.chapters}话</span>
        </div>
      </div>
    </Link>
  );
}